{
  "serviceForms": {
    "giftCardInformationForm": {
      "labels": {
        "availableGiftCardValue": "Lahjakortin arvo"
      }
    },
    "manageCompensationForm": {
      "error": {
        "cancelled": "Tämä korvaus on peruttu. Ota yhteyttä asiakaspalveluumme.",
        "converted": "Olet valinnut korvaustavaksi rahakorvauksen. Huomaathan, että maksussa saattaa kestää 3–14 arkipäivää.",
        "expired": "Valitettavasti et voi enää muokata tätä korvaushakemusta.",
        "locked": "Tämä korvaus on tällä hetkellä lukittu. Saat lisätietoja olemalla yhteydessä asiakaspalveluumme.",
        "notFound": "Emme löytäneet tätä korvausta. Tarkistathan syöttämäsi kirjautumistunnuksen ja PIN-koodin. Asiakaspalvelumme auttaa mielellään mikäli tarvitset apua.",
        "requestError": "Emme pystyneet käsittelemään pyyntöäsi. Yritäthän myöhemmin uudelleen."
      },
      "fields": {
        "giftCardId": {
          "label": "Kirjautumistunnus",
          "pattern": "Kirjautumistunnus on virheellisessä muodossa.",
          "required": "Kirjautumistunnus on pakollinen."
        },
        "giftCardPin": {
          "label": "PIN-koodi",
          "pattern": "PIN-koodi ei ole oikeassa muodossa.",
          "required": "PIN-koodi on pakollinen."
        }
      },
      "labels": {
        "convertToCash": "Ilmoita pankkitietosi",
        "expiresOn": "Valitse korvaustapa viimeistään:"
      },
      "steps": {
        "giftCardConversion": {
          "confirmationLabel": "Syöttämällä PIN-koodin vahvistat, että yllä olevat tiedot ovat oikein ja haluat saada korvauksen rahana.",
          "formDescription": "Voit valita sinulle sopivimman korvaustavan."
        },
        "giftCardInformation": {
          "title": "Tietoa korvauksestasi"
        },
        "giftCardVerification": {
          "footnotes": [
            "Löydät <strong>kirjautumistunnuksen</strong> ja <strong>PIN-koodin</strong> sähköpostista. Olet saanut sähköpostin joko Finnairilta, tai sinulle lahjakortin antaneelta henkilöltä."
          ],
          "title": "Ilmoita korvaustapa"
        }
      }
    }
  }
}
